module.exports = __webpack_public_path__ + "img/icn_venue_white.39c8425c.svg";